import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators, FormArray } from '@angular/forms';
import { Expense} from 'app/shared/types/expense';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExpenseService } from 'app/shared/services/expense.service';
import { DialogService } from 'app/shared/services/dialog.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { AuthService } from 'app/shared/services/auth.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { map, startWith } from 'rxjs/operators';
import { Observable} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import * as moment from 'moment';



@Component({
  selector: 'app-expense',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.css']
})
export class ExpenseComponent implements OnInit {

  isDark: boolean = false;

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();


  expense:Expense;
  expenseData = [];
  bankAccountList : any[];
  expenseForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isBtnDisabled : boolean= false;
  isShowAttachBtn: boolean=false;
  isHideBtn: boolean= false;
  bsClassToShow : boolean = false;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  

  myControl = new FormControl();
  filteredOptions: Observable<any[]>[] = [];
  expNameList: any[]=[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };


  EXP_TYPES =[
    {value: 'Administration'},
    {value: 'Repair and Maintenance'},
    {value: 'Outside Vehicle Rent'},
    {value: 'Salary'},
    {value: 'Finance'},
    {value: 'Other'},
  ];


  validationMessages = {
    'expNo': { 'required': 'Expense number is required' },
    'expDate': { 'required': 'Date is required' },
    'paymentType': {'required': 'Payment type is required' },
    'paymentAccount': {'required': 'Payment Account is required' },
  };

  formErrors = {
    'expNo': "",
    'expDate': "",
    'paymentType': "",
    'paymentAccount': "",
  };

  PMT_TYPE =[
    {value: 'Cash'},
    {value: 'Cheque'},
    {value: 'Card Payment'},
    {value: 'Bank Transfer'},

  ];


  constructor(private fb: FormBuilder,
    private expenseService: ExpenseService,
    private dialogService: DialogService,
    private authService: AuthService,
    private toastr: ToastrService,
    private route : ActivatedRoute,
    private fileUploadService:FileUploadService,
    private router : Router,
    private themeService: NbThemeService,
    private bankAccountsService: BankAccountsService
    )
  {
    this.datepickerConfig = Object.assign({},
      {   
        showWeekNumbers:false,
        dateInputFormat : 'YYYY-MM-DD'
      });



  }

ngOnInit() {

  this.initExpType();
  this.initFormFields();

  this.isBtnDisabled = true;
 
  this.disableForm();
  this.viewExpById();
  this.getExpNameList();
  this.getBankAccountList();
  this.getControlPermissions();

  this.expenseForm.valueChanges.subscribe((data) => {
    this.logValidationErrors(this.expenseForm);
    });

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });

}// end oninit

getControlPermissions(){
  var data = [];
   data =  this.authService.controlPermissionArray.filter((el)=>{
    return el.moduleCode ==='EXP'
  });
  if(data.length > 0){
    this.crud_access.read = data[0].read;
    this.crud_access.create = data[0].create;
    this.crud_access.approve = data[0].approve;
    this.crud_access.delete = data[0].delete;
  }
}

autoComplete(index: number){
  this.filteredOptions[index] = this.getExpItems.at(index).get('expName').valueChanges
  .pipe(
    startWith(''),
      map(value => this._filter(value))
  );
}


private _filter(expName: string): any[] {
  if(expName){
    const filterValue = expName.toLowerCase();
    return this.expNameList.filter(option => option.ExpName.toLowerCase().indexOf(filterValue) === 0);
  }
}

getExpNameList(){
  this.expenseService.getAllExpNames()
   .subscribe(
      (data) => {
                this.expNameList= data;  
          
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
     
   }

   getBankAccountList(){
    this.bankAccountsService.getAllBankAccounts()
     .subscribe(
        (data) => {  
                  this.bankAccountList = data           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }
 

initExpType() : void{

  this.expense = {
    expNo: '',
    expDate: '',
    paymentType: '',
    paymentAccount: '',
    paymentRefNo : '',
    expName: '',
    expCategory: '',
    amount: 0.00,
    remarks : '',
    expTotal: 0.00,
    createdBy : '',
  };
}

initFormFields() : void{
  this.expenseForm = this.fb.group({
    expNo : ['',Validators.required],
    expDate : ['',Validators.required],
    paymentType : [null,Validators.required],
    paymentAccount: [null,Validators.required],
    paymentRefNo : [''],
    expItems : this.fb.array([this.addExpItem()]), 
     
  });
  this.autoComplete(0);

}


newButtonClick(): void {
  this.isfieldReadOnly  = false;
  this.isHideBtn= false;
  this.isBtnDisabled = false;
  this.isShowAttachBtn=false; 
  this.expenseForm.reset();
  this.enableForm();
  this.resetOtherControls();
  this.getMaxId();
  this.addItemButtonClick();

  this.expenseForm.patchValue({
    expDate:  this.defaultDate,
  });
  
   
 }

 getMaxId(){
  var expNo = 0;
  var expNoPrefixZero  : String;

  this.expenseService.getMaxId()
  .subscribe(
    (res) => {
        expNo = Number(res[0].ExpNo) + 1;
        expNoPrefixZero = expNo.toString().padStart(6,'0');       
        this.expenseForm.patchValue({
          expNo : "EXP" + expNoPrefixZero
        });
       
    },        
    (err) =>  {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              }, 
    )

 }


 addExpItem() : FormGroup{  
  return this.fb.group({
   expName : ['',Validators.required],
   expCategory : [null,Validators.required],
   amount : ['',Validators.required],
   remarks : [''],

  });
 
}



 get getExpItems(){
    return this.expenseForm.get('expItems') as FormArray;
 }




  addItemButtonClick() : void {
      this.getExpItems.push(this.addExpItem());
      this.autoComplete(this.getExpItems.length-1)
      this.updateBillTotal();
  }

  removeItemButtonClick(itemIndex : number) : void{
    this.getExpItems.removeAt(itemIndex);
    this.filteredOptions.splice(itemIndex, 1);
    this.updateBillTotal();
  }

  resetOtherControls() : void{
      this.getExpItems.clear();
      this.expense.expTotal = 0.00;
      this.bsClassToShow = false;
  }



updateBillTotal(){
  this.expense.expTotal = this.getExpItems.value.reduce((prev,curr)=>prev + +curr.amount, 0);
  
}


mapFormValuesToModel(){
  this.expenseData =[];
  var result = [];
 
  for(let i=0; i < this.getExpItems.length; i++){

  this.expense.expNo=this.expenseForm.value.expNo;
  this.expense.expDate=this.expenseForm.value.expDate;
  this.expense.paymentType=this.expenseForm.value.paymentType;
  this.expense.paymentAccount=this.expenseForm.value.paymentAccount;
  this.expense.paymentRefNo=this.expenseForm.value.paymentRefNo;
  this.expense.expName = this.getExpItems.value[i].expName;
  this.expense.expCategory=this.getExpItems.value[i].expCategory;
  this.expense.amount=this.getExpItems.value[i].amount;
  this.expense.remarks=this.getExpItems.value[i].remarks;
  this.expense.expTotal=this.expense.expTotal;
  this.expense.createdBy =this.authService.getUserLoggedIn();
  
  this.expenseData.push(
    this.expense.expNo,
    this.expense.expDate,
    this.expense.paymentType,
    this.expense.paymentAccount,
    this.expense.paymentRefNo,
  
    this.expense.expName,
    this.expense.expCategory,
    this.expense.amount,
    this.expense.remarks,

    this.expense.expTotal,
    this.expense.createdBy,

    );

  }

  while(this.expenseData.length){
    result.push(this.expenseData.splice(0,11));
  }

  return result;

}

 
saveButtonClick(): void {
  this.logValidationErrors(this.expenseForm,true);
  var data = this.mapFormValuesToModel();

  if(this.isFilledFromFields()){
      this.showProcessingIndicator = true;
        this.expenseService.addExpense(data)
        .subscribe(
          (res) =>{
            if(res.success === 0){
              this.expenseForm.patchValue({
              expNo : res.autoId
              });
            this.saveButtonClick();
            this.showProcessingIndicator = false; 
            
            }else if(res.success === 1){
              this.toastr.success('Expense added successfully','Success');
              this.isfieldReadOnly  = true;
              this.isBtnDisabled = true;
              this.isShowAttachBtn = true;
              this.disableForm(); 
              this.showProcessingIndicator = false;
           }   
          },
          (err) =>{
            this.toastr.error('Failed to add expense','Failure'); 
            this.showProcessingIndicator = false;   
            if(err instanceof HttpErrorResponse){                 
              if(err.status == 401){
                this.router.navigate(['/login']);
              }
            }
            console.log(err);
          }
        )
      } 

  else{
        this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
        this.showProcessingIndicator = false;                                                                                                                                                                                                   
      } 
 }



 enableForm():void{
  Object.keys(this.expenseForm.controls).forEach(key => {
    this.expenseForm.controls[key].enable();
    //console.log("Enable "+key)     
  });

}


disableForm():void{
  Object.keys(this.expenseForm.controls).forEach(key => {
    this.expenseForm.controls[key].disable();
   // console.log("disable "+key);
  });

}

logValidationErrors(group: FormGroup = this.expenseForm,isDirty :boolean=false): void {
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    this.formErrors[key] = '';
    if(isDirty)
    {
      this.enableForm();
      this.expenseForm.controls[key].markAsTouched();
    }
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.validationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } 
  });
}

isFilledFromFields() : boolean {  
  (<FormArray>this.expenseForm.get('expItems')).controls.forEach((group: FormGroup) => {
    (<any>Object).values(group.controls).forEach((control: FormControl) => { 
        control.markAsTouched();
    }) 
  });

  for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }
       if(this.getExpItems.length==0 || this.expenseForm.get('expItems').invalid){
          return false;
       }
      return true;
}





  viewExpById(){
      var hasExpNo;
      var expNo;

      hasExpNo=this.route.snapshot.queryParamMap.has('expNo');
       
        if(hasExpNo){
          expNo = this.route.snapshot.queryParamMap.get('expNo')
          this.expenseService.getExpense(expNo)
          .subscribe(
            (data) => {
                      if(data){
                        this.patchValuesToForm(data); 
                        this.disableForm(); 
                        this.isfieldReadOnly = true;
                        this.isBtnDisabled = true;  
                        this.isShowAttachBtn = true; 
                        this.bsClassToShow = true; 
                        this.isHideBtn= true;                    
                       }
                      },
          (err) => 
                    {
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    });
    }else{
      this.newButtonClick();
    }

  }

patchValuesToForm(data){

this.expenseForm.patchValue({  
  expNo : data[0].ExpNo,
  expDate : moment(data[0].ExpDate).format("YYYY-MM-DD"),
  paymentType : data[0].PaymentType,
  paymentAccount : data[0].PaymentAccount,
  paymentRefNo : data[0].PaymentRefNo,
});

this.expenseForm.setControl('expItems',this.setExpItems(data));
this.expense.expTotal= data[0].ExpTotal;


}


setExpItems(data) : FormArray{
  const expItemArray = new FormArray([]);
  for(let i =0; i < data.length;i++){ 
    expItemArray.push(this.fb.group({
      expName : [data[i].ExpName],
      expCategory : [data[i].ExpCategory],
      amount : [data[i].Amount],  
      remarks : [data[i].Remarks]  
    }));
  }
  return expItemArray;
}

attachFileButtonClick(){
  this.fileUploadService.refNo = this.expenseForm.value.expNo;
   const dialogConfig = new MatDialogConfig();
   dialogConfig.disableClose = true;
   dialogConfig.autoFocus = true;
   dialogConfig.width = "75%";
   this.dialogService.openDialog(FileUploadComponent,dialogConfig);
      
  }


 viewExpButtonClick(){  
      var expNo = this.expenseForm.get('expNo').value;
      if(expNo){
      this.router.navigate(['../espense'],{queryParams : {'expNo':expNo},relativeTo : this.route});    
      }   
   }

}
